// Replaces lodash noop function.
export const noop = () => undefined;
